import styled from 'styled-components';

export const TitleDeleteQuestion = styled.p`
    font-family: 'Roboto';
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 5px;
`;
